export const LogoMark = ({ className = "w-8 h-8" }) => (
  <img src="/logo.png" alt="Logo DIMORA" className={`${className} rounded-full object-cover`} />
);

export const Brand = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className={compact ? "w-9 h-9" : "w-11 h-11"} />
    <span className="flex flex-col leading-none">
      <span className="font-display font-bold tracking-[0.18em] text-white text-lg">DIMORA</span>
      <span className="text-[9px] uppercase tracking-[0.28em] text-amber-300/90 mt-1">Nettoyage & Entretien</span>
    </span>
  </span>
);
